import { CodiceFiscale } from "codice-fiscale-js";

// Validazione Codice Fiscale: 16 caratteri alfanumerici + carattere di controllo finale.
// La libreria codice-fiscale-js gestisce correttamente anche i codici omocodi
// (sostituzioni L,M,N,P,Q,R,S,T,U,V al posto delle cifre) nel calcolo del check digit.
export function validateCodiceFiscale(raw) {
  const v = String(raw || "").trim().toUpperCase();
  if (!v) return { state: "empty" };
  if (v.length !== 16) return { state: "error", error: "Il codice fiscale deve avere 16 caratteri." };
  if (!/^[A-Z0-9]{16}$/.test(v)) return { state: "error", error: "Il codice fiscale contiene caratteri non validi." };
  let ok = false;
  try { ok = CodiceFiscale.check(v); } catch { ok = false; }
  if (!ok) return { state: "error", error: "Codice fiscale non valido: carattere di controllo errato." };
  return { state: "valid" };
}

// Validazione IBAN italiano: IT + 2 cifre di controllo + 23 caratteri (27 totali),
// con verifica delle cifre di controllo tramite algoritmo MOD97 (ISO 13616).
export function validateIBAN(raw) {
  const v = String(raw || "").replace(/\s+/g, "").toUpperCase();
  if (!v) return { state: "empty" };
  if (!/^IT\d{2}[A-Z0-9]{23}$/.test(v)) {
    return { state: "error", error: "IBAN italiano non valido: formato atteso IT + 2 cifre + 23 caratteri (27 totali)." };
  }
  const rearranged = v.slice(4) + v.slice(0, 4);
  const expanded = rearranged.replace(/[A-Z]/g, (c) => (c.charCodeAt(0) - 55).toString());
  let rem = 0;
  for (let i = 0; i < expanded.length; i++) {
    rem = (rem * 10 + (expanded.charCodeAt(i) - 48)) % 97;
  }
  if (rem !== 1) return { state: "error", error: "IBAN non valido: cifre di controllo errate (MOD97)." };
  return { state: "valid" };
}
